// Strategic regional hubs with lat/lon for the 88 Days map
// Focus: mining towns, farm work hubs, tourism (Northern AU), and key metros
// All coordinates are approximate (city center).

export const REGIONAL_HUBS = [
  // ===== WA — Mining & Pilbara =====
  { name: "Karratha", state: "WA", postcode: 6714, lat: -20.7364, lng: 116.846, type: "mining" },
  { name: "Port Hedland", state: "WA", postcode: 6721, lat: -20.3104, lng: 118.6011, type: "mining" },
  { name: "Newman", state: "WA", postcode: 6753, lat: -23.357, lng: 119.7331, type: "mining" },
  { name: "Tom Price", state: "WA", postcode: 6751, lat: -22.6925, lng: 117.7919, type: "mining" },
  { name: "Kalgoorlie", state: "WA", postcode: 6430, lat: -30.7489, lng: 121.4658, type: "mining" },
  { name: "Broome", state: "WA", postcode: 6725, lat: -17.9614, lng: 122.2359, type: "tourism" },
  { name: "Kununurra", state: "WA", postcode: 6743, lat: -15.7781, lng: 128.7378, type: "farm" },
  { name: "Carnarvon", state: "WA", postcode: 6701, lat: -24.8842, lng: 113.6611, type: "farm" },
  { name: "Margaret River", state: "WA", postcode: 6285, lat: -33.9551, lng: 115.0758, type: "farm" },
  { name: "Manjimup", state: "WA", postcode: 6258, lat: -34.2419, lng: 116.1469, type: "farm" },
  { name: "Geraldton", state: "WA", postcode: 6530, lat: -28.7777, lng: 114.6149, type: "farm" },
  { name: "Esperance", state: "WA", postcode: 6450, lat: -33.8612, lng: 121.8916, type: "farm" },

  // ===== QLD — Farm & Mining =====
  { name: "Cairns", state: "QLD", postcode: 4870, lat: -16.9186, lng: 145.7781, type: "tourism" },
  { name: "Port Douglas", state: "QLD", postcode: 4877, lat: -16.4839, lng: 145.4612, type: "tourism" },
  { name: "Mackay", state: "QLD", postcode: 4740, lat: -21.142, lng: 149.1818, type: "mining" },
  { name: "Bowen", state: "QLD", postcode: 4805, lat: -20.0125, lng: 148.2459, type: "farm" },
  { name: "Ayr", state: "QLD", postcode: 4807, lat: -19.5746, lng: 147.4053, type: "farm" },
  { name: "Innisfail", state: "QLD", postcode: 4860, lat: -17.5238, lng: 146.0314, type: "farm" },
  { name: "Tully", state: "QLD", postcode: 4854, lat: -17.9333, lng: 145.9333, type: "farm" },
  { name: "Bundaberg", state: "QLD", postcode: 4670, lat: -24.866, lng: 152.3489, type: "farm" },
  { name: "Childers", state: "QLD", postcode: 4660, lat: -25.2358, lng: 152.2811, type: "farm" },
  { name: "Stanthorpe", state: "QLD", postcode: 4380, lat: -28.6533, lng: 151.9408, type: "farm" },
  { name: "Mount Isa", state: "QLD", postcode: 4825, lat: -20.7256, lng: 139.4927, type: "mining" },
  { name: "Townsville", state: "QLD", postcode: 4810, lat: -19.2576, lng: 146.8178, type: "tourism" },
  { name: "Rockhampton", state: "QLD", postcode: 4700, lat: -23.3781, lng: 150.5136, type: "farm" },

  // ===== NSW — Farm =====
  { name: "Griffith", state: "NSW", postcode: 2680, lat: -34.2887, lng: 146.0537, type: "farm" },
  { name: "Mildura (border)", state: "VIC", postcode: 3500, lat: -34.1855, lng: 142.1625, type: "farm" },
  { name: "Orange", state: "NSW", postcode: 2800, lat: -33.2839, lng: 149.0997, type: "farm" },
  { name: "Tamworth", state: "NSW", postcode: 2340, lat: -31.0927, lng: 150.9302, type: "farm" },
  { name: "Coffs Harbour", state: "NSW", postcode: 2450, lat: -30.2963, lng: 153.1135, type: "farm" },
  { name: "Byron Bay", state: "NSW", postcode: 2481, lat: -28.6474, lng: 153.6020, type: "tourism" },

  // ===== VIC — Farm =====
  { name: "Shepparton", state: "VIC", postcode: 3630, lat: -36.3833, lng: 145.4 , type: "farm" },
  { name: "Echuca", state: "VIC", postcode: 3564, lat: -36.1333, lng: 144.75, type: "farm" },
  { name: "Robinvale", state: "VIC", postcode: 3549, lat: -34.5833, lng: 142.7833, type: "farm" },
  { name: "Swan Hill", state: "VIC", postcode: 3585, lat: -35.3389, lng: 143.5544, type: "farm" },

  // ===== NT =====
  { name: "Katherine", state: "NT", postcode: 850, lat: -14.4644, lng: 132.2635, type: "farm" },
  { name: "Alice Springs", state: "NT", postcode: 870, lat: -23.6980, lng: 133.8807, type: "tourism" },

  // ===== SA =====
  { name: "Renmark", state: "SA", postcode: 5341, lat: -34.1722, lng: 140.7475, type: "farm" },
  { name: "Berri", state: "SA", postcode: 5343, lat: -34.2825, lng: 140.5994, type: "farm" },
  { name: "Mount Gambier", state: "SA", postcode: 5290, lat: -37.8294, lng: 140.7828, type: "farm" },

  // ===== TAS =====
  { name: "Devonport", state: "TAS", postcode: 7310, lat: -41.18, lng: 146.35, type: "farm" },
  { name: "Launceston", state: "TAS", postcode: 7250, lat: -41.4332, lng: 147.1441, type: "farm" },

  // ===== Major METROS (for reference — NOT eligible) =====
  { name: "Sydney", state: "NSW", postcode: 2000, lat: -33.8688, lng: 151.2093, type: "metro" },
  { name: "Melbourne", state: "VIC", postcode: 3000, lat: -37.8136, lng: 144.9631, type: "metro" },
  { name: "Brisbane", state: "QLD", postcode: 4000, lat: -27.4698, lng: 153.0251, type: "metro" },
  { name: "Perth", state: "WA", postcode: 6000, lat: -31.9523, lng: 115.8613, type: "metro" },
  { name: "Adelaide", state: "SA", postcode: 5000, lat: -34.9285, lng: 138.6007, type: "metro" },
  { name: "Hobart", state: "TAS", postcode: 7000, lat: -42.8821, lng: 147.3272, type: "metro" },
  { name: "Darwin", state: "NT", postcode: 800, lat: -12.4634, lng: 130.8456, type: "metro" },
];
